<script>
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';

export default {
    page: {
        title: "Orders",
        meta: [{ name: "description", content: appConfig.description }],
    },
    props: {
        customerid :{
            type : Number,
        }
    },
    data(){
        return {
            customer_contract_info:[],
            loadingDetail:false,
            loadingRoles:true,
            ButtonSeen:true,
        };  
    },

    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY')
            }
        },

        get_customer_order_by_id(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_API_BASEURL+'contract/customer_contract/'+this.customerid)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.customer_contract_info = response.data;
                    console.log(this.customer_contract_info);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        }, 

        getCurrency() {
            return process.env.VUE_CURRENCY || 'SGD';
        },

    },

    components: {
        DataTable,
    },

    mounted() {
        this.get_customer_order_by_id();     
    },
};
require("@/assets/css/datatable.css");
</script>

<template>
  <div class="card card-height-100">
    <div class="card-body p-0">
      <div>
        <div v-if='loadingRoles'>
              <div class="spinner-border text-success" role="status">
                  <span class="sr-only">Loading...</span>
              </div>
          </div>
          <div v-else>
            <div class="table-responsive">
                <DataTable :options="{lengthChange: false}" class="table table-striped table-nowrap mb-0"> 
                    <thead class="table-secondary">
                         <tr>
                            <th>#.</th>
                            <th scope="col">Contract Number</th>           
                            <th scope="col">Customer Name</th>           
                            <th scope="col">SKU</th>           
                            <th scope="col">IMEI</th>           
                            <th scope="col">Order Number</th>                                                      
                            <th scope="col">Program</th>
                            <th scope="col">Device Name</th>
                            <th scope="col">Price</th>
                            <th scope="col">Contract Signed Date</th>
                        </tr>
                    </thead>
                    <tbody>                                
                        <tr v-for="(item, index) in customer_contract_info" :key="index" class="content">
                            <td>{{ index+1 }}</td>
                            <td><router-link :to="'/contracts/customer-contract-details/'+item.contract_id" class="fw-medium link-secondary">{{ item.contract_number }}</router-link></td>                               
                            <!--td>{{ item.orderId }}</td-->
                            <td>{{ item.name_as_per_nric }}</td>
                            <td>{{ item.sku }}</td>
                            <td>{{ item.imei }}</td>
                            <td>{{ item.orderId }}</td>
                            <td>{{ item.program_name }}</td>                                          
                            <td>{{ item.product_name }}</td>                                          
                            <td>{{ this.getCurrency() }} {{ item.price }}</td>                                                                                  
                            <td>{{ this.format_date(item.commencement_date) }}</td>                                                                                  
                        </tr>
                    </tbody>
                </DataTable>
            </div>
        </div>
      </div>
    </div>
  </div>



</template>
